import { isNil } from '@lucidlink/tscore';
import { executeCallback, getFullKey, getKeyPrefix, normalizeKey, } from '#kv-storage/drivers/utils';
export function initStorageGeneric(options, createDb, createSerializer) {
    const dbInfo = {
        db: createDb(),
        keyPrefix: getKeyPrefix(options, this._defaultConfig),
    };
    this._dbInfo = dbInfo;
    void this.getSerializer().then((serializer) => {
        dbInfo.serializer = createSerializer(serializer);
    });
}
export function getItemGeneric(key, callback) {
    key = normalizeKey(key);
    const promise = this.ready().then(() => {
        const { db, keyPrefix, serializer } = this._dbInfo;
        const fullKey = getFullKey(key, keyPrefix);
        const result = db.get(fullKey);
        if (isNil(result)) {
            return null;
        }
        return serializer.deserialize(result);
    });
    executeCallback(promise, callback);
    return promise;
}
export function setItemGeneric(key, value, callback) {
    key = normalizeKey(key);
    const promise = this.ready().then(() => {
        if (isNil(value)) {
            value = null;
        }
        const originalValue = value;
        const { db, keyPrefix, serializer } = this._dbInfo;
        const fullKey = getFullKey(key, keyPrefix);
        return new Promise((resolve, reject) => {
            void serializer.serialize(value, (value, error) => {
                if (error) {
                    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- preserve existing non-Error rejection (behavior-neutral migration); v8 newly enforces this
                    reject(error);
                    return;
                }
                try {
                    db.put(fullKey, value);
                    resolve(originalValue);
                }
                catch (e) {
                    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors -- preserve existing non-Error rejection (behavior-neutral migration); v8 newly enforces this
                    reject(e);
                }
            });
        });
    });
    executeCallback(promise, callback);
    return promise;
}
export function removeItemGeneric(key, callback) {
    key = normalizeKey(key);
    const promise = this.ready().then(() => {
        const { db, keyPrefix } = this._dbInfo;
        const fullKey = getFullKey(key, keyPrefix);
        db.remove(fullKey);
    });
    executeCallback(promise, callback);
    return promise;
}
export function clearGeneric(callback) {
    const promise = this.ready().then(() => {
        const { db } = this._dbInfo;
        db.clear();
    });
    executeCallback(promise, callback);
    return promise;
}
export function lengthGeneric(callback) {
    const promise = this.ready().then(() => {
        const { db } = this._dbInfo;
        return db.length();
    });
    executeCallback(promise, callback);
    return promise;
}
export function keyGeneric(n, callback) {
    const promise = this.ready().then(() => {
        const { db, keyPrefix } = this._dbInfo;
        const keys = db.keys();
        const key = keys[n];
        if (isNil(key)) {
            return null;
        }
        return key.slice(keyPrefix.length);
    });
    executeCallback(promise, callback);
    return promise;
}
export function keysGeneric(callback) {
    const promise = this.ready().then(() => {
        const { db } = this._dbInfo;
        return db.keys();
    });
    executeCallback(promise, callback);
    return promise;
}
export function iterateGeneric(iteratee, callback) {
    const promise = this.ready().then(() => {
        void iteratee;
        return undefined;
    });
    executeCallback(promise, callback);
    return promise;
}
export function dropInstanceGeneric(dbInstanceOptions, callback) {
    void dbInstanceOptions;
    return this.clear(callback);
}
